export { createClient as createRestClient } from 'contentful';
export type { BaseEntry } from 'contentful';
export * from './src/utils';
export * from './src/queries';
